import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import RegistrationFormView from "../LandingPage/Screens/Registration/RegistrationFormView/RegistrationFormView";
import AN13FormView from "../LandingPage/Screens/RegisterAN13/RegisterAN13FormView/AN13FormView";
import CustomerListView from "../LandingPage/Screens/Customer/CustomerListView/CustomerListView";
import ChangePassword from "../Auth/screens/ChangePassword/ChangePassword";
import Dashboard from "swfrontend/DASHBOARD/Dashboard";
import { SCREEN_ROUTES, URLS } from "../LandingPage/constants";

export const app = URLS.PORTAL_URL;
const user = localStorage.getItem('pk');

function getRoutes() {
  return {
    UpdateRegistrationForm: {
      component: RegistrationFormView,
      routers: [
        <Switch>
          <Route
            exact
            path={`${app}/${SCREEN_ROUTES.UPDATE_REGISTRATION_FORM}/:id`}
            component={RegistrationFormView}
          />

          <Route
            exact
            path={`${app}/${SCREEN_ROUTES.CHANGE_PASSWORD}`}
            component={ChangePassword}
          />

          <Redirect
            to={`${app}/${SCREEN_ROUTES.UPDATE_REGISTRATION_FORM}/${user}`}
          />
        </Switch>,
      ],
    },
    CustomerList: {
      component: CustomerListView,
      routers: [
        <Switch>
          <Route
            exact
            path={`${app}/${SCREEN_ROUTES.CUSTOMER_LIST}`}
            component={CustomerListView}
          />
          <Route
            exact
            path={`${app}/${SCREEN_ROUTES.VIEW_REGISTRATION_FORM}/:id`}
            component={RegistrationFormView}
          />
        </Switch>,
      ],
    },
    Register: {
      component: RegistrationFormView,
      routers: [
        <Switch>
          <Route
            exact
            path={`${app}/${SCREEN_ROUTES.REGISTER}`}
            component={RegistrationFormView}
          />
        </Switch>,
      ],
    },

    RegisterFME: {
      component: AN13FormView,
      routers: [
        <Switch>
          <Route exact path={`${URLS.REGISTERFME}`} component={AN13FormView}/>
        </Switch>
      ],
    }
  };
}

export default getRoutes;
